import { action } from 'typesafe-actions';
import { EstadoCidadeTypes, IEstado, ICidade, IEstadoSelecionado } from './types';

export const loadRequestEst = () => action(EstadoCidadeTypes.LOAD_ESTADO_REQUEST, {});
export const loadSuccessEst = (estado: IEstado[]) =>
  action(EstadoCidadeTypes.LOAD_ESTADO_SUCCESS, { estado });
export const loadFailureEst = () => action(EstadoCidadeTypes.LOAD_ESTADO_FAILURE, {});

export const loadRequestCid = (codUf: number) =>
  action(EstadoCidadeTypes.LOAD_CIDADE_REQUEST, { codUf });
export const loadSuccessCid = (data: ICidade[]) =>
  action(EstadoCidadeTypes.LOAD_CIDADE_SUCCESS, { data });
export const loadFailureCid = () => action(EstadoCidadeTypes.LOAD_CIDADE_FAILURE, {});

export const clean = () => action(EstadoCidadeTypes.CLEAN, {});

export const stateSelect = (estadoSelecionado: IEstadoSelecionado) =>
  action(EstadoCidadeTypes.STATE_SELECT, { estadoSelecionado });

export const citySelect = (cidadeSelecionada: any) =>
  action(EstadoCidadeTypes.CITY_SELECT, { cidadeSelecionada });

export const nameSelect = (nomeSelecionado: any) =>
  action(EstadoCidadeTypes.NAME_SELECT, { nomeSelecionado });

export const nameParcSelect = (nomeParcSelecionado: any) =>
  action(EstadoCidadeTypes.NAME_PARC_SELECT, { nomeParcSelecionado });

export const cnpjSelect = (cnpjSelecionado: any) =>
  action(EstadoCidadeTypes.CNPJ_SELECT, { cnpjSelecionado });

export const cnpjAutoCompSelect = (cnpjAutoCompSelecionado: any) =>
  action(EstadoCidadeTypes.CNPJ_AUTO_COMP, { cnpjAutoCompSelecionado });
